module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("4Sbgd"))).then(() => parcelRequire('37nVf'));